<template>
    <div class="row">
        <div class="form-inline col-md-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="grey lighten-1" class="tooltip-small">
                            mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Select additional analyses to run.</span>
            </v-tooltip>

            <i class="fas fa-chart-area"></i> <span style="padding-left: 5px;">Analyses </span>
        </div>

        <div class="col-md-10">
            <div class="row">

                <div class="col-md-3" :class="[$store.getters.getUserPermissions.includes('feature-activation-analyses-crossvisitation') ? 'push-down-36' : '']">

                    <v-tooltip
                        v-if="!$store.getters.getUserPermissions.includes('feature-activation-analyses-crossvisitation')"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="blue lighten-1">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Contact your account manager <br> to use this functionality.</span>
                    </v-tooltip>

                    <v-switch
                        :color="colors.cv_toggle"
                        v-model="cross_visitation"
                        inset
                        :disabled="!$store.getters.getUserPermissions.includes('feature-activation-analyses-crossvisitation') || is_dataset_eligible_for_analyses"
                        label="CrossVisitation"
                    ></v-switch>
                </div><!--form-group-->
                <div class="col-md-3" :class="[$store.getters.getUserPermissions.includes('feature-activation-analyses-frequency') ? 'push-down-36' : '']">

                    <v-tooltip
                        v-if="!$store.getters.getUserPermissions.includes('feature-activation-analyses-frequency')"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="blue lighten-1">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Contact your account manager <br> to use this functionality.</span>
                    </v-tooltip>

                    <v-switch
                        :color="colors.fq_toggle"
                        v-model="frequency"
                        inset
                        :disabled="is_frequency_analysis_allowed || is_dataset_eligible_for_analyses"
                        label="Frequency"
                    ></v-switch>
                </div><!--form-group-->
                <div class="col-md-3" :class="[$store.getters.getUserPermissions.includes('feature-activation-analyses-distance') ? 'push-down-36' : '']">
                    <v-tooltip
                        v-if="!$store.getters.getUserPermissions.includes('feature-activation-analyses-distance')"
                        top
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon color="blue lighten-1">
                                    mdi-information-outline
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>Contact your account manager <br> to use this functionality.</span>
                    </v-tooltip>

                    <v-switch
                        :color="colors.ds_toggle"
                        v-model="distance"
                        inset
                        :disabled="is_distance_analysis_allowed || is_dataset_eligible_for_analyses"
                        label="Distance"
                    ></v-switch>
                </div><!--form-group-->
            </div>
        </div>
    </div>
</template>

<script>
import analyses from "../../../../../mixin/analyses";

export default {
    name: "AnalysesSelection",
    mixins: [analyses],
    props: [],
    data: () => ({
        //
    }),
    methods: {
        //
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        is_frequency_analysis_allowed() {
            return !this.$store.getters.getUserPermissions.includes('feature-activation-analyses-frequency') ||
                (
                    (
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.cohorts &&
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](1) === this.analyses.types.cohorts
                    ) ||
                    (
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.cohorts &&
                        this.$store.getters['CreateAudienceStore/getQuery'] === 'Single'
                    )
                )
        },
        is_distance_analysis_allowed() {
            return !this.$store.getters.getUserPermissions.includes('feature-activation-analyses-distance') ||
                (
                    (
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.cohorts &&
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](1) === this.analyses.types.cohorts
                    ) ||
                    (
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.cohorts &&
                        this.$store.getters['CreateAudienceStore/getQuery'] === 'Single'
                    ) ||
                    (
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](0) === this.analyses.types.apps ||
                        this.$store.getters['CreateAudienceStore/getAnalysisType'](1) === this.analyses.types.apps
                    )
                )
        },
        is_dataset_eligible_for_analyses() {
            let eligibility = true
            let datasets = [this.$store.getters['CreateAudienceStore/getAnalysisType'](0), this.$store.getters['CreateAudienceStore/getAnalysisType'](1)]


            if (Array.from(new Set(datasets)).length > 1 && this.$store.getters['CreateAudienceStore/getQuery'] === "OR") {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'cross_visitation',
                    value: false
                })
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'frequency',
                    value: false
                })
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'distance',
                    value: false
                })

                eligibility = false
            }

            return !eligibility
        },
        audience: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesAudienceStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'audience',
                    value: value
                })
            }
        },
        cross_visitation: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'cross_visitation',
                    value: value
                })
            }
        },
        frequency: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesFrequencyStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'frequency',
                    value: value
                })
            }
        },
        distance: {
            get() {
                return this.$store.getters['CreateAudienceStore/getAnalysesDistanceStatus']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_ANALYSES_STATUS', {
                    analysis: 'distance',
                    value: value
                })
            }
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>